<template>
  <div id="pembayaran-detail">
    <!-- begin breadcrumb -->
    <ol class="breadcrumb pull-right">
      <li>
        <router-link :to="{ path: '/' }">Home</router-link>
      </li>
      <li>Pembayaran</li>
      <li>
        <router-link :to="{ path: '/pembayaran' }"
          >List Pembayaran User</router-link
        >
      </li>
      <li class="active">Manual Input</li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">Manual Input Transaksi</h1>
    <!-- end page-header -->
    <div class="row">
      <div class="col-md-12">
        <div class="panel panel-inverse">
          <div class="panel-heading">
            <h4 class="panel-title">Input Transaksi</h4>
          </div>
          <div class="panel-body">
            <!-- begin form -->
            <form>
              <div class="form-horizontal form-bordered">
                <div class="form-group">
                  <label class="col-md-2 control-label">Email</label>
                  <div class="col-md-6 col-xs-6">
                    <input
                      type="text"
                      class="form-control"
                      v-model="email"
                    /><br />
                    <textarea
                      v-if="isUserValidated"
                      name=""
                      id=""
                      rows="2"
                      class="form-control"
                      readonly
                      v-model="txtUserInfo"
                    >
                    </textarea>
                  </div>
                  <div class="col-md-4 col-xs-4">
                    <button class="btn btn-success" @click="doQueryUser()">
                      Check
                    </button>
                  </div>
                </div>
                <div class="form-group" v-if="isUserValidated">
                  <label class="col-md-2 control-label">Product</label>
                  <div class="col-md-6 col-xs-6">
                    <select class="form-control" v-model="form.product_id">
                      <option
                        v-for="product in products"
                        :key="product.id"
                        :value="product.id"
                      >
                        [{{ product.type }}] {{ product.title }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="form-group" v-if="isUserValidated">
                  <label class="col-md-2 control-label">Payment Method</label>
                  <div class="col-md-6 col-xs-6">
                    <select class="form-control" v-model="form.payment_id">
                      <option
                        v-for="paymentMethod in paymentMethods"
                        :key="paymentMethod.id"
                        :value="paymentMethod.id"
                      >
                        [{{ paymentMethod.type }}] {{ paymentMethod.bank_name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="form-group" v-if="isUserValidated">
                  <label class="col-md-2 control-label">User Bank Name</label>
                  <div class="col-md-6 col-xs-6">
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.bank_name"
                    />
                  </div>
                </div>
                <div class="form-group" v-if="isUserValidated">
                  <label class="col-md-2 control-label"
                    >User Bank Account</label
                  >
                  <div class="col-md-6 col-xs-6">
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.account_name"
                    />
                  </div>
                </div>
                <div class="form-group" v-if="isUserValidated">
                  <label class="col-md-2 control-label">Payment Slip</label>
                  <div class="col-md-8 col-xs-12">
                    <div class="row">
                      <div class="col-md-4" v-if="form.payment_slip_url">
                        <img
                          :src="form.payment_slip_url"
                          style="max-width: 100%"
                          ref="banner"
                          alt="avatar"
                        />
                      </div>
                      <div class="col-md-8">
                        <app-imagecropper
                          v-on:finished="onFileChanged($event)"
                          v-bind:aspectRatio="2"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <!-- end form -->
          </div>
          <div class="panel-footer" v-if="isUserValidated">
            <div class="form-group">
              <div class="col-md-12 col-xs-12">
                <button class="btn btn-success pull-right" @click="save()">
                  SIMPAN
                </button><br />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-spinner v-if="isLoading"></app-spinner>
  </div>
</template>
<script>
import AppSpinner from "@/components/plugins/Spinner";
import AuthService from "@/services/auth.js";
import SalesService from "@/services/sales.js";
import FileService from "@/services/file.js";
import ImageCropper from "@/components/plugins/ImageCropper";

export default {
  name: "manual-input",
  components: {
    "app-spinner": AppSpinner,
    "app-imagecropper": ImageCropper,
  },
  data: function () {
    return {
      isUserValidated: false,
      isLoading: false,
      userData: null,
      products: [],
      paymentMethods: [],
      email: null,
      selectedPicture: null,
      form: {
        user_id: null,
        product_id: null,
        payment_id: null,
        bank_name: null,
        account_name: null,
        payment_slip_url: null,
      },
    };
  },
  methods: {
    doQueryUser: function () {
      var data = { email: this.email };
      var context = this;
      this.isLoading = true;
      AuthService.queryUser(data, function (result) {
        context.isLoading = false;
        if (result.success) {
          context.userData = result.data;
          context.isUserValidated = true;
          context.form.user_id = result.data.id
          context.loadProductData();
          context.loadPaymentMethodData();
        } else {
          window.alert("Data user tidak ditemukan");
        }
      });
    },
    loadProductData: function () {
      var grade = this.userData.profile.grade;
      var context = this;

      var pagination = { currentPage: 1, perPage: 100 };
      var search = { by: "grade", query: grade };
      SalesService.getProdukList(pagination, search, function (result) {
        if (result.success) {
          context.products = result.data;
        }
      });
    },
    loadPaymentMethodData: function () {
      var context = this;
      var pagination = { currentPage: 1, perPage: 100 };
      var search = null;
      SalesService.getMetodePembayaranList(
        pagination,
        search,
        function (result) {
          if (result.success) {
            context.paymentMethods = result.data;
          }
        }
      );
    },
    onFileChanged(event) {
      var fileName = event.url.split("/")[3] + ".jpg";
      var path = "sales/transactions/user_" + this.userData.id + "/" + fileName;
      var context = this;
      var imageData = event.blob;
      this.isLoading = true;
      FileService.upload(imageData, path, function (response) {
        if (response.success) {
          var imageUrl =
            "https://" +
            process.env.OSS_BUCKET_NAME +
            "." +
            process.env.OSS_ENDPOINT +
            "/" +
            response.data;

          context.form.payment_slip_url = imageUrl;
        }

        context.isLoading = false;
      });
    },
    save() {
      var context = this;
      var isConfirmed = window.confirm(
        "Apakah anda yakin data ini sudah benar?"
      );
      if (isConfirmed) {
        this.isLoading = true;
        SalesService.createManualTransaction(this.form, function (response) {
          if (response.success) {
            context.$router.push("/pembayaran");
          }

          context.isLoading = false;
        });
      }
    },
  },
  computed: {
    txtUserInfo: function () {
      return (
        "[" +
        this.userData.id +
        "]" +
        " " +
        this.userData.profile.name +
        " - " +
        this.userData.profile.school
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// Form.vue?c395512c